import { useAuth } from "../../context/auth-context";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";
import type {
  AdminPayoutTransactionsDataEnvelope,
  AdminPayoutTransactionsDataPayload,
} from "./adminTransactionsData";

const DEFAULT_LIMIT = 25;

export type UseAdminPayoutTransactionsDataParams = {
  page: number;
  search?: string;
  startDate?: string;
  endDate?: string;
  limit?: number;
  enabled?: boolean;
};

/**
 * Paginated payout rows from GET api/admin/transactions/data (type=payouts, no orderSubtypes).
 */
export function useAdminPayoutTransactionsDataQuery(
  params: UseAdminPayoutTransactionsDataParams
) {
  const { isAuthenticated } = useAuth();
  const {
    page,
    search,
    startDate,
    endDate,
    limit = DEFAULT_LIMIT,
    enabled: enabledParam = true,
  } = params;

  return useApiQuery<
    AdminPayoutTransactionsDataEnvelope,
    AdminPayoutTransactionsDataPayload
  >({
    queryKey: apiQueryKey("admin-transactions-data", {
      type: "payouts",
      page,
      limit,
      search: search?.trim() || null,
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/data",
    params: {
      type: "payouts",
      page,
      limit,
      search: search?.trim() || undefined,
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
